export default "__VITE_ASSET__Bmti_H2x__";